"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const formik_1 = require("formik");
const uuid_1 = require("uuid");
// MUI
const mui_1 = require("tss-react/mui");
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const InputBase_1 = __importDefault(require("@mui/material/InputBase"));
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const MoreVertRounded_1 = __importDefault(require("@mui/icons-material/MoreVertRounded"));
const renameRulesActions_1 = require("companion-app-components/flux/rename-rules/renameRulesActions");
const renameRulesTypes_1 = require("companion-app-components/flux/rename-rules/renameRulesTypes");
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const Dump_1 = __importDefault(require("components/Dump"));
const utils_1 = require("../../utils");
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const BootstrapInput = (0, mui_1.withStyles)(InputBase_1.default, (theme) => ({
    input: Object.assign(Object.assign({ backgroundColor: theme.palette.greyScaleDeprecated[7], borderRadius: 4, border: `1px solid ${theme.palette.divider}`, color: theme.palette.greyScaleDeprecated[0], marginLeft: -10, position: 'relative', padding: '5px 20px 5px 10px', transition: theme.transitions.create(['border-color', 'box-shadow']) }, theme.typography.body2), { width: 130, '&:focus': {
            borderRadius: 4,
            borderColor: theme.palette.blue4,
            boxShadow: `0 0 0 0.2rem ${theme.applyOpacityToHex(theme.palette.blue4, 0.25)}`,
        } }),
}));
const RulesRow = ({ editable, disableAll, setDisableAll, row, removeNewTempRule, rules }) => {
    const [subMenuAnchorEl, setSubMenuAnchorEl] = React.useState(null);
    const { classes } = useStyles();
    const [isEditable, setEditable] = React.useState(editable);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const open = Boolean(subMenuAnchorEl);
    const handleSubMenuClick = (event) => {
        setSubMenuAnchorEl(event.currentTarget);
    };
    const handleCloseSubMenu = () => {
        setSubMenuAnchorEl(null);
    };
    const handleEditable = (disable) => {
        setEditable(disable);
        setDisableAll(disable);
        handleCloseSubMenu();
        if (removeNewTempRule) {
            removeNewTempRule();
        }
    };
    const handleFormCancel = () => {
        handleEditable(false);
    };
    const onSubmitForm = (data) => {
        if (data.id === 0) {
            const clientId = (0, uuid_1.v4)().toUpperCase();
            dispatch((0, renameRulesActions_1.createRenameRule)((0, renameRulesTypes_1.mkRenameRule)(Object.assign(Object.assign({}, data), { id: null, clientId })), { undo: { userMessage: 'New rule created.' } }));
        }
        else {
            dispatch((0, renameRulesActions_1.updateRenameRule)((0, renameRulesTypes_1.mkRenameRule)(data), { undo: { userMessage: 'Rule updated.' } }));
        }
        handleEditable(false);
    };
    const onDelete = () => {
        dialogAlert('Delete Confirmation', 'Are you sure you want to delete this renaming rule?', ({ btnPressed }) => {
            if (btnPressed !== 'Yes') {
                return;
            }
            dispatch((0, renameRulesActions_1.deleteRenameRule)((0, renameRulesTypes_1.mkRenameRule)(row).set('isDeleted', true), { undo: { userMessage: 'Rule deleted.' } }));
        }, ['Yes', 'No']);
    };
    return (<Slide_1.default direction="left" in mountOnEnter unmountOnExit timeout={800}>
      <TableRow_1.default component="div" hover role="checkbox" tabIndex={-1}>
        <formik_1.Formik validateOnMount initialValues={(0, utils_1.initializeRenameRuleForm)(row)} onSubmit={onSubmitForm} validate={(values) => {
            const errors = {};
            if (!values.renamePayeeTo || values.renamePayeeTo.trim().length === 0) {
                errors.renamePayeeTo = 'Required';
            }
            else if (!values.renamePayeeFrom || values.renamePayeeFrom.trim().length === 0) {
                errors.renamePayeeFrom = 'Required';
            }
            return errors;
        }}>
          {({ isValid, values, setFieldError, resetForm }) => (<>
              <TableCell_1.default className={classes.tableCell} component="div">
                <Dump_1.default obj={values}/>

                <formik_1.Field name="renamePayeeTo" render={({ field }) => !isEditable ?
                <Typography_1.default variant="body2">{field.value}</Typography_1.default> :
                <BootstrapInput id="rename-payee-to" {...field}/>}/>
              </TableCell_1.default>

              <TableCell_1.default className={classes.tableCell} component="div">
                <formik_1.Field name="matchCriteria" render={({ field }) => (!isEditable ?
                <Typography_1.default variant="body2">{field.value}</Typography_1.default> :
                <Select_1.default {...field} input={<BootstrapInput id="match-criteria"/>}>
                        <MenuItem_1.default value="If Payee Contains">If Payee Contains</MenuItem_1.default>
                        <MenuItem_1.default value="If Quicken name is">If Quicken name is</MenuItem_1.default>
                      </Select_1.default>)}/>
              </TableCell_1.default>

              <TableCell_1.default className={classes.tableCell} component="div">
                <formik_1.Field name="renamePayeeFrom" render={({ field }) => !isEditable ?
                <Typography_1.default variant="body2">{field.value}</Typography_1.default> :
                <BootstrapInput id="rename-payee-from" {...field}/>}/>

              </TableCell_1.default>

              <TableCell_1.default className={classes.tableCell} align="right" component="div">
                {isEditable ?
                <>
                    <Button_1.default size="small" onClick={() => {
                        handleFormCancel();
                        resetForm();
                    }} color="primary" type="button">
                      Cancel
                    </Button_1.default>
                    <Button_1.default size="small" type="submit" color="primary" disabled={!isValid} onClick={() => {
                        if (rules.remove(values.id)
                            .some((rule) => rule.renamePayeeFrom === values.renamePayeeFrom)) {
                            setFieldError('renamePayeeFrom', '');
                            dialogAlert('That item already exists!', 'Sorry, but that item already exists, you need to use a unique Downloaded Name.', null, ['Got it']);
                        }
                        else {
                            onSubmitForm(values);
                        }
                    }}>
                      Save
                    </Button_1.default>
                  </> :
                <>
                    <IconButton_1.default onClick={handleSubMenuClick} disabled={disableAll} size="small">
                      <MoreVertRounded_1.default />
                    </IconButton_1.default>
                    <Menu_1.default id="long-menu" anchorEl={subMenuAnchorEl} keepMounted open={open} onClose={handleCloseSubMenu} TransitionComponent={Fade_1.default} PaperProps={{ elevation: 1 }}>
                      <MenuItem_1.default onClick={() => handleEditable(true)}>Edit</MenuItem_1.default>
                      <MenuItem_1.default onClick={onDelete}>Delete</MenuItem_1.default>
                    </Menu_1.default>
                  </>}
              </TableCell_1.default>
            </>)}
        </formik_1.Formik>
      </TableRow_1.default>
    </Slide_1.default>);
};
exports.default = RulesRow;
